<template>
    <Fieldset :title="$t('labels.basic_information')">
        <div class="row">
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.name')" :required="true">
                    <Input v-model="arrivalDeclarationStatus.name" type="string" />
                </FormGroup>
            </div>
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.type')" :required="true">
                    <Select v-model="arrivalDeclarationStatus.type" :options="arrivalDeclarationStatusTypesOptions" :disabled="arrivalDeclarationStatus.uuid != null" optionKey="key" optionValue="value" />
                </FormGroup>
            </div>
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.color')" :required="true">
                    <Input v-model="arrivalDeclarationStatus.color" type="color" />
                </FormGroup>
            </div>
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.queue')">
                    <Input v-model="arrivalDeclarationStatus.order" type="string" />
                </FormGroup>
            </div>
        </div>
    </Fieldset>
</template>
<script>
import Input from '../../../../../components/new/form/Input.vue'
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue'
import Fieldset from '../../../../../components/new/AppFieldset.vue'
import Select from '../../../../../components/new/form/select/Select.vue'
import { ArrivalDeclarationStatusTypeEnum } from '../../../../enums/ArrivalDeclarationStatusTypeEnum'
export default {
    name: "ArrivalDeclarationStatusFieldsetGroup",
    components: {
        Input, FormGroup, Fieldset, Select
    },
    props: {
        arrivalDeclarationStatus: {
            type: Object,
            required: true
        }
    },
    computed: {
        arrivalDeclarationStatusTypesOptions() {
            return Object.values(ArrivalDeclarationStatusTypeEnum).map((value) => {
                return {
                    key: value,
                    value: this.$t(`enum.arrival-declaration-status.type.${value}`)
                }
            })
        }
    }
}
</script>
